
  export default {
    computed: {
      flash () {
        return this.$store.getters['utils/getFlash'];
      },
      message () {
        if (this.flash && this.flash.message) {
          const message = this.flash.message;
          return (message.match(/^i18n_/)) ? this.$t(message.replace(/^i18n_/, 'errors.')) : message.replace(/\/$/, '');
        }
        return null;
      }
    },
    mounted () {
      if (this.$route.query.flashMessage) {
        this.$store.dispatch('utils/flashMessage', { class: this.$route.query.flashClass, message: this.$route.query.flashMessage });
        this.$router.replace(this.$route.path);
      }
    }
  };
